<template>
	<div>
		<CubePage type="myorder-view" title="客源统计">
			<div slot="content" class="content">
				<div class="main">
					<div class="tbox datalist">
						<div id="mainPre" ref="mainPre" style="width: 100%;height:120px;"></div>
						<div class="tbox-list">
							<div class="flex " v-for=" (item,index) in kyList" :key="index">
								<div class="l-date">
									{{item.name}}
								</div>
								<div class="r-num">
									{{item.value}}人
								</div>
							</div>
						</div>
					</div>
					<div class="wl datalist">
						<p>客源地前十</p>
						<div class="scroll">
							<div v-if="listObj.length>0" class="flex" v-for=" (item,i) in listObj">
								<div class="l-date">
									{{item.name}}
								</div>
								<div class="r-num">
									{{item.value}}人
								</div>
							</div>
							<div class="no-data" v-else>
								暂无数据
							</div>
						</div>
					</div>
				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import * as echarts from 'echarts';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				listObj:null,
				kyList:null
			}
		},
		created() {
			this.initht()
			this.onYSearch()
		},
		methods: {
			initht() {
				this.$nextTick(() => {
					this.onSearch()
					// this.initBt()
				})
			},
			initBt(data) {
				var chartDom = document.getElementById('mainPre');
				var myChart = echarts.init(chartDom); 
				myChart.clear();
				myChart.resize()
				var option;

				option = {
					title: {
						text: '团散比',
						left: 'center',
						textStyle: {
							color: '#00ffff',
							fontWeight: 'normal',
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center',
						show: false
					},
					series: [{
						top:20,
						name: '团散比',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						data: data,
						label: {
							color: '#fff',
							formatter: `{b}\n{d}%`,
						}
					}]
				};
				option && myChart.setOption(option);
				window.onresize = function() {
					myChart.resize()
				}
			},
			async onSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getChannelGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function(result) {
						that.kyList=result.data.list
						that.initBt(result.data.list)
					},
				);
			},
			async onYSearch() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getSourceGroupList"
				//这里直接调用网络接口
				await util.post(url, {},
					function(result) {
						that.listObj=result.data.list
					},
				);
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	.main {
		height: calc(100vh - 44px);
		overflow-x: hidden;
		overflow-y: scroll;
		background: linear-gradient(to bottom, #00557f 30%, #0072a7);

		.tbox {
			padding: 10px;

			.tbox-list {
				margin: 0 25px;
			}
		}

		.datalist {
			margin: 20px 10px;
			padding: 10px;
			border-radius: 10px;
			box-shadow: 2px 2px 10px #fafafa;

		}

		.datalist {
			text-align: center;
			line-height: 30px;
			color: #fff;

			.ii span {
				color: #ffaa00;
				font-weight: 600;
				font-size: 18px;
				padding: 0 10px;
				letter-spacing: 3px;
			}

			.flex {
				display: flex;
				justify-content: space-between;
				padding: 4px 0;

				.l-date {
					color: #00abfa;
				}

				.r-num {
					font-size: 16px;
					color: #ffff7f;
				}
			}

		}

		.wl {
			// height: calc(100% - 260px);

			.scroll {
				height: calc(100% - 50px);
				overflow-y: scroll;
				overflow-x: hidden;
			}

			.scroll::-webkit-scrollbar {
				display: none;
			}

			p {
				text-align: center;
				padding: 10px;
				color: #fff;
				font-size: 20px;
			}

		}

		.header-title {
			padding: 10px;
			text-align: center;
			color: #fff;
			text-shadow: 3px 5px 5px #656B79;

			h1 {
				font-size: 18px;
			}

			h3 {
				padding-top: 6px;
				font-size: 16px;
			}
		}
	}
</style>
